import fetchAnnouncements from '#/repository/fetch-announcements';
import {useQuery} from '@tanstack/react-query';

const refetchInterval = 5 * 60 * 1000;
export const useAnnouncements = () => {
  return useQuery({
    queryKey: ['announcements'],
    queryFn: async () => {
      const announcementsResult = await fetchAnnouncements();
      return announcementsResult?.messages.map((message, index) => ({id: index, message}));
    },
    refetchInterval,
  });
};
